import api from "./httpClientInstance";
import API_ENDPOINTS from "../config/Endpoints";

// Generate OTP for login (sends OTP to existing user's mobile)
export const generateLoginOtp = async (payload) => {
    const response = await api.post(API_ENDPOINTS.AUTHENTICATE, payload);
    return response;
}

// Login user with OTP verification
export const loginUser = async (payload) => {
    const response = await api.post(API_ENDPOINTS.USER_LOGIN, payload);
    return response;
}

// Generate OTP for signup (sends OTP to new user's mobile)
export const generateSignupOtp = async (payload) => {
    const response = await api.post(API_ENDPOINTS.GENERATE_OTP, payload);
    return response;
}

// Verify OTP (both login and signup)
export const verifyOtp = async (payload) => {
    const response = await api.post(API_ENDPOINTS.VERIFY_OTP, payload);
    return response;
}

// Register new user after OTP verification
export const registerUser = async (payload) => {
    const response = await api.patch(API_ENDPOINTS.REGISTER_USER, payload);
    return response;
}

// Update user's free view and post limits
export const updateFreeViewPostLimit = async (payload) => {
    const response = await api.post(API_ENDPOINTS.UPDATE_FREE_VIEW_POST_LIMIT, payload);
    return response;
}

// Get User Profile details (free view/post limits)
export const getUserProfileDetails = async () => {
    const response = await api.get(API_ENDPOINTS.USER_PROFILE);
    return response;
}

// Update User Profile details (PATCH)
export const updateUserProfileDetails = async (payload) => {
    // If payload is FormData (for image upload) or regular object
    const headers = payload instanceof FormData 
        ? { "Content-Type": "multipart/form-data" } 
        : { "Content-Type": "application/json" };

    const response = await api.patch(API_ENDPOINTS.USER_PROFILE, payload, { headers });
    return response;
}
